import { render, staticRenderFns } from "./trade-form.vue?vue&type=template&id=17599f8a&lang=html&"
import script from "./trade-form.vue?vue&type=script&lang=js&"
export * from "./trade-form.vue?vue&type=script&lang=js&"
import style0 from "./trade-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports